import React from 'react'
import { Box, ListItem, ListItemText } from '@mui/material'
import List from '@mui/material/List'

export const DamageStat: React.FC<{
  title: string
  entries: [string, string][]
  translation: { [key: string]: string }
}> = ({ entries, translation, title }) => {
  return (
    <>
      <Box>{title}</Box>
      <List sx={{ padding: '0px', margin: '0px' }}>
        {entries
          .filter(s => s[1] && s[1] !== '')
          .filter(s => s[0] !== 'id')
          .map(dmg => (
            <ListItem sx={{ padding: '0px', paddingLeft: '16px' }} key={dmg[0]}>
              <ListItemText
                sx={{ marginTop: '0px', marginBottom: '0px', marginRight: '16px' }}
                secondary={translation[dmg[0]] || dmg[0]}
              />
              <span>
                <ListItemText sx={{ marginTop: '0px', marginBottom: '0px' }} secondary={dmg[1]} />
              </span>
            </ListItem>
          ))}
      </List>
    </>
  )
}
